import React, { useState } from "react";

import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import routes from "routes";
import { useSelector } from "react-redux";
import AccessControl, { check } from "../../RBAC/AccessControl";
import rules from "../../../rbac-rules";
import permissions from "../../../permissions";
import MaterialUITable from "../../Custom/MaterialUITable";
import { DeleteOutline } from "@material-ui/icons";
import axios from "axios";
import useAgentList from "api/useAgentList";
import notifySuccess, { notifyFail } from "utils/Toast";
import { ConfirmDeleteDialog } from "containers/UserAgent/List/ConfirmDeleteDialog";
import UrlManagerPopup from "containers/UserAgent/Create/UrlManagerPopup";
import useUrlList from "api/useUrlList";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  addButton: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export default function UserAgentTableComponent(props) {
  const { userAgents, setDeleted } = props;
   const [isUrlDeleted,setUrlDeleted]= useState('');
      const { isLoading, userAgentsUrl } = useUrlList(isUrlDeleted); 
  let history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { currentUser } = useSelector((state) => state.users);
  const canEdit = check(rules, currentUser.role, [permissions.agencies.update]);
  const [selectedAgent, setSelectedAgent] = React.useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleDeleteAgent = async (id) => {
    console.log(id);
    const result = await axios.delete(
      `${routes.userAgent.endpoint}/delete/${id}`,
    );
    if (result.status === 200) {
      setDeleted(result);
      notifySuccess("Agent is deactivated Successfully.");
    } else {
      notifyFail("Failed to deactivate agent");
    }
  };

  const handleDeleteClick = (rowData) => {
    setSelectedAgent(rowData);
    setOpen(true);
  };

  const handleConfirmDelete = () => {
    handleDeleteAgent(selectedAgent); // Your existing delete logic
    setOpen(false);
  };

  const handleStatusToggle = async (id, newStatus) => {
    console.log("ID:", id, "New Status:", newStatus);
    const result = await axios.put(`${routes.userAgent.endpoint}/${id}`);
    if (result.status === 200) {
      setDeleted(result);
      notifySuccess("Agent is updated Successfully.");
    } else {
      notifyFail("Failed to update agent");
    }
  };
  console.log(isPopupOpen);
  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardHeader
              title={routes.userAgent.pageTitle}
              subheader="The following agents have been configured in AdComplyRx.
                            You can add additional agents or edit agents from this screen."
              action={
                <AccessControl
                  allowedPermissions={[permissions.userAgents.create]}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.addButton}
                    onClick={() => history.push(`${routes.userAgent.path}/new`)}
                  >
                    Add User Agent
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.addButton}
                    onClick={() => setIsPopupOpen(true)}
                  >
                    User Agent URL
                  </Button>

                  <UrlManagerPopup
                    open={isPopupOpen}
                    onClose={() => setIsPopupOpen(false)}
                    setUrlDeleted={setUrlDeleted}
                    userAgentsUrl={userAgentsUrl}
                  />
                </AccessControl>
              }
            />
            <Divider />
            <CardContent className={classes.cardContent}>
              <MaterialUITable
                title=""
                data={userAgents}
                columns={[
                  { title: "User Agents", field: "userAgent" },
                  {
                    title: "Created At",
                    field: "dateCreated",
                    render: (rowData) => {
                      return rowData.dateCreated
                        ? rowData.dateCreated.split("T")[0]
                        : "";
                    },
                  },
                  {
                    title: "UA-Updated DateByBrowser",
                    field: "updateUADateByBrowser",
                    render: (rowData) => {
                      // If usageCount is 0 or null, display 0, otherwise display the number
                      return rowData.updateUADateByBrowser !== undefined &&
                        rowData.updateUADateByBrowser !== null
                        ? rowData.updateUADateByBrowser.split("T")[0]
                        : 0;
                    },
                  },

                  {
                    title: "Days Difference",
                    render: (rowData) => {
                      if (rowData.updateUADateByBrowser) {
                        const today = new Date();
                        const updated = new Date(rowData.updateUADateByBrowser);

                        // Calculate difference in milliseconds
                        // Using (today - updated) ensures a positive number if the update was in the past
                        const diffInMs = today - updated;

                        // Convert to days: ms / (1000ms * 60s * 60m * 24h)
                        const diffInDays = Math.floor(
                          diffInMs / (1000 * 60 * 60 * 24),
                        );

                        // Handle cases where the date might be in the future or today
                        return diffInDays >= 0
                          ? `${diffInDays} Days`
                          : "0 Days";
                      }
                      return "N/A";
                    },
                  },

                  {
                    title: "Status",
                    field: "status",
                    
                    render: (rowData) => (
                      <Switch
                        checked={rowData.status}
                        color="secondary"
                        onChange={() =>
                          handleStatusToggle(rowData.id, !rowData.status)
                        }
                        
                      />
                    ),
                  },
                ]}
                options={{
                  filtering: false,
                  sorting: true,
                  actionsColumnIndex: -1,
                  // Ensure all 9 records show by increasing the default page size
                  paging: false,
                  headerStyle: {
                    // backgroundColor: '#4caf50',
                    color: "rgb(14 103 58)",
                    fontWeight: "bold",
                  },
                }}
                localization={{
                  header: { actions: "Action" },
                }}
                actions={[
                  {
                    icon: "delete",
                    tooltip: "Delete Agent",
                    onClick: (event, rowData) => handleDeleteClick(rowData.id),
                  },
                ]}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <ConfirmDeleteDialog
        open={open}
        handleClose={() => setOpen(false)}
        handleConfirm={handleConfirmDelete}
        agentName={selectedAgent?.userAgent}
      />
    </div>
  );
}
